import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { useScrollToTop } from '../hooks/useScrollToTop';

interface BackToTopButtonProps {
  showAfter?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const BackToTopButton: React.FC<BackToTopButtonProps> = ({
  showAfter = 300,
  className = '',
  size = 'md'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollToTop } = useScrollToTop();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > showAfter) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // 添加滚动事件监听器
    window.addEventListener('scroll', toggleVisibility);

    // 清理函数
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [showAfter]);

  const handleClick = () => {
    scrollToTop({ behavior: 'smooth' });
  };

  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={handleClick}
      className={`
        fixed bottom-6 right-6 z-50
        ${sizeClasses[size]}
        bg-primary-600 hover:bg-primary-700
        text-white
        rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-300
        flex items-center justify-center
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        transform hover:scale-110
        ${className}
      `}
      aria-label="Back to top"
      title="Back to top"
    >
      <ChevronUp className={iconSizes[size]} />
    </button>
  );
};
